import { getIndustriesList } from 'services/clients'
import { useQuery } from 'react-query'

export const useIndustries = () => {
  const industries = useQuery(['industriesList'], getIndustriesList, {
    retry: false,
  })
  return industries
}
